import React from "react";
import logo from "./logo.svg";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";
import BOP010W010 from "./bop010/bop010w010/bop010w010";
import BOP020W010 from "./bop020/bop020w010/bop020w010";
import BOP020W020 from "./bop020/bop020w020/bop020w020";
import BOP020W030 from "./bop020/bop020w030/bop020w030";
import BOP020W040 from "./bop020/bop020w040/bop020w040";
import BOP030W010 from "./bop030/bop030w010/bop030w010";
import BOP030W020 from "./bop030/bop030w020/bop030w020";
import BOP030W030 from "./bop030/bop030w030/bop030w030";
import CommonLayout from "./common/commonLayout";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* ログイン画面 */}
        <Route path="/" element={<BOP010W010 />} />
        {/* ログイン後（共通レイアウト） */}
        <Route element={<CommonLayout />}>
          <Route path="/bop020w010" element={<BOP020W010 />} />
          <Route path="/bop020w020" element={<BOP020W020 />} />
          <Route path="/bop020w030" element={<BOP020W030 />} />
          <Route path="/bop020w040" element={<BOP020W040 />} />
          <Route path="/bop030w010" element={<BOP030W010 />} />
          <Route path="/bop030w020" element={<BOP030W020 />} />
          <Route path="/bop030w030" element={<BOP030W030 />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
